import { Route, Routes } from '@angular/router';

export const content: Routes = [
  {
    path: '',
    redirectTo: 'app',
    pathMatch: 'full',
  },
  {
    path: 'app',
    loadChildren: () => import('../../pages/pages.module').then(m => m.PagesModule),
    data: {
      breadcrumb: ''
    }
  }
];